import { ADMIN_ROLES } from '@/modules/base/util/constants'
import type { AiChatPersona } from '@ai-chat-widget-contracts/contracts'

export interface PersonaUserInfo {
  isAdminLogin?: boolean
  isOwner?: boolean
  roles?: string[]
}

export interface PersonaSubscription {
  isTrial?: boolean
  isExpired?: boolean
  isCancelled?: boolean
  isSubscriptionLocked?: boolean
}

export interface PersonaSubscriptionState {
  loading: boolean
  subscriptions?: readonly PersonaSubscription[]
}

const isActiveSubscription = (subscription: PersonaSubscription): boolean => !subscription.isExpired
  && !subscription.isSubscriptionLocked
  && (!subscription.isCancelled || subscription.isTrial === true)

const isAdministrator = (userInfo: PersonaUserInfo): boolean => userInfo.isAdminLogin === true
  || userInfo.isOwner === true
  || (userInfo.roles || []).some(role => ADMIN_ROLES.includes(role))

export const resolvePersona = (
  userInfo: PersonaUserInfo,
  subscriptionState?: PersonaSubscriptionState,
): AiChatPersona | undefined => {
  const administrator = isAdministrator(userInfo)
  if (!subscriptionState || subscriptionState.loading) return administrator ? 'admin' : undefined

  const subscriptions = subscriptionState.subscriptions || []
  const activeSubscriptions = subscriptions.filter(isActiveSubscription)

  if (activeSubscriptions.length > 0 && activeSubscriptions.every(subscription => subscription.isTrial === true)) return 'trial'
  if (administrator) return 'admin'
  if (subscriptions.length > 0 && activeSubscriptions.length === 0) return 'churned'

  return 'customer'
}
